export default __webpack_public_path__ + "static/media/no-prospect-note.70968539.svg";